import _regeneratorRuntime from "@babel/runtime/regenerator";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { Head, Link } from '@inertiajs/inertia-vue3';
import Layout from '@/Shared/Layout';

import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message/style/css';
export default {
  components: {
    Head: Head,
    Link: Link
  },
  layout: Layout,
  props: {
    tenantList: {
      type: Array,
      "default": []
    },
    user_type: {
      type: String,
      "default": ""
    }
  },
  data: function data() {
    return {
      tenant: '',
      campaignList: [],
      campaign: '',
      campaignTargetList: false,
      memberList: []
    };
  },
  methods: {
    getCampaignList: function getCampaignList() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.campaignList = [];
                _this.memberList = [];
                if (!(_this.tenant.length == 0)) {
                  _context.next = 4;
                  break;
                }
                return _context.abrupt("return");
              case 4:
                _this.$store.loading = true;
                _context.next = 7;
                return axios.post('/target/campaign_list', {
                  tenantId: _this.tenant
                });
              case 7:
                res = _context.sent;
                if (res.data.status == 'success') {
                  _this.campaignList = res.data.campaignList;
                }
                _this.$store.loading = false;
              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getMemberList: function getMemberList() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.memberList = [];
                if (!(_this2.tenant.length == 0 || _this2.campaign.length == 0)) {
                  _context2.next = 3;
                  break;
                }
                return _context2.abrupt("return");
              case 3:
                _this2.$store.loading = true;
                _context2.next = 6;
                return axios.post('/target/member_list', {
                  tenantId: _this2.tenant,
                  campaignId: _this2.campaign
                });
              case 6:
                res = _context2.sent;
                if (res.data.status == 'success') {
                  _this2.memberList = res.data.memberList;
                }
                _this2.$store.loading = false;
              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    saveData: function saveData(rowData) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(rowData.contacts == 0)) {
                  _context3.next = 3;
                  break;
                }
                ElMessage({
                  showClose: true,
                  message: 'Contact target cannot be zero.',
                  type: 'error'
                });
                return _context3.abrupt("return");
              case 3:
                if (!(rowData.companies == 0)) {
                  _context3.next = 6;
                  break;
                }
                ElMessage({
                  showClose: true,
                  message: 'Company target cannot be zero.',
                  type: 'error'
                });
                return _context3.abrupt("return");
              case 6:
                if (!(rowData.contacts < rowData.companies)) {
                  _context3.next = 9;
                  break;
                }
                ElMessage({
                  showClose: true,
                  message: 'Contact target cannot be less than company target.',
                  type: 'error'
                });
                return _context3.abrupt("return");
              case 9:
                if (!(rowData.companies != 0 && rowData.contacts != 0)) {
                  _context3.next = 18;
                  break;
                }
                _this3.$store.loading = true;
                _context3.next = 13;
                return axios.post('/target/save_target', rowData);
              case 13:
                res = _context3.sent;
                ElMessage({
                  showClose: true,
                  message: res.data.message,
                  type: res.data.status
                });
                _this3.$store.loading = false;
                _context3.next = 18;
                return _this3.getMemberList();
              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getNoTargetReport: function getNoTargetReport() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var res;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.$store.loading = true;
                _context4.next = 3;
                return axios.post('/target/no_target_report');
              case 3:
                res = _context4.sent;
                ElMessage({
                  showClose: true,
                  message: res.data.message,
                  type: res.data.status
                });
                _this4.$store.loading = false;
              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }
};